import type { QuoteFlowStepName } from "./analytics";
import { serverStation, serverStepFor } from "./step-routes";

/** Where a call-gate outcome sends the family: wherever the server now
 * derives, or straight into the application. */
export type CallGateDestination = "derived" | "application";

export interface CallGateLanding {
  /** The server step the view moves to before navigating; null leaves
   * the view as it stands. */
  viewStep: string | null;
  /** The station the family ends on. */
  route: QuoteFlowStepName;
  /** A station written over the current history entry first, so Back
   * from `route` returns to it rather than to the schedule-call station
   * the derivation has already moved past; null pushes `route` alone. */
  historyBase: QuoteFlowStepName | null;
}

/**
 * The landing for a call-gate write. `serverStep` is the step the server
 * answered with, or null when the write failed. The derived destination
 * follows the server's answer and, on failure, falls back to the quote
 * screen with the view untouched. The application destination always
 * moves the view past the schedule call (the landing rule caps every
 * station at the derived step) and enters the application over the quote
 * screen.
 */
export function callGateLanding(
  destination: CallGateDestination,
  serverStep: string | null,
): CallGateLanding {
  if (destination === "application") {
    return {
      viewStep: serverStep ?? serverStepFor("quote"),
      route: "application",
      historyBase: "quote",
    };
  }
  if (serverStep === null) {
    return { viewStep: null, route: "quote", historyBase: null };
  }
  return {
    viewStep: serverStep,
    route: serverStation(serverStep),
    historyBase: null,
  };
}
